module.exports = __webpack_public_path__ + "img/vdara7.b55a86f8.jpg";